import { render } from "./PostImageFullScreenSlide.vue?vue&type=template&id=5e78661b"
import script from "./PostImageFullScreenSlide.vue?vue&type=script&lang=js"
export * from "./PostImageFullScreenSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__